var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"tweet","d":"M19.74,4.6a7.6,7.6,0,0,1-2.294.633,3.766,3.766,0,0,0,1.74-2.215,7.579,7.579,0,0,1-2.532.949A3.876,3.876,0,0,0,13.728,2.7,4.052,4.052,0,0,0,9.693,6.735a3.852,3.852,0,0,0,.079.949A11.369,11.369,0,0,1,1.466,3.491,4.11,4.11,0,0,0,.912,5.469a4.025,4.025,0,0,0,1.82,3.4A4.769,4.769,0,0,1,.912,8.4v.079A4.07,4.07,0,0,0,4.155,12.43a4.63,4.63,0,0,1-1.028.158,2.968,2.968,0,0,1-.791-.079,3.942,3.942,0,0,0,3.8,2.769,7.79,7.79,0,0,1-4.984,1.74A3.852,3.852,0,0,1,.2,16.94a11.539,11.539,0,0,0,6.171,1.82A11.4,11.4,0,0,0,17.841,7.288V6.735A10.134,10.134,0,0,0,19.74,4.6","transform":"translate(-0.2 -2.7)","fill":"#fff"}));
}

Twitter.defaultProps = {"width":"19.54","height":"16.059","viewBox":"0 0 19.54 16.059"};

module.exports = Twitter;

Twitter.default = Twitter;
